/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  IIndustryFocusData,
  IIndustryFocusDataState,
  IIndustryFocusOptionList,
} from "../../Interfaces/SiteContent";

/**
 * Industry Focus data selector.
 */
export const getIndustryFocus = (state: IIndustryFocusDataState): IIndustryFocusData[] =>
  state.industryFocuses;

/**
 * Industry Focus option list data selector.
 */
export const getIndustryFocusOptionList = (
  state: IIndustryFocusDataState
): IIndustryFocusOptionList[] => state.industryFocusesOptionList;

/**
 * Industry Focus data load error selector.
 */
export const getIndustryFocusLoadError = (state: IIndustryFocusDataState): string =>
  state.industryFocusLoadError;
